import { Box, Flex, HStack } from "@chakra-ui/react";
import React, { useState } from "react";
import { FaRegCopy } from "react-icons/fa6";

const JustLaunched = () => {
  const string = "6VXq8brmqKJ2whzpmPypMvrzitgmYYE3bvjrVdXsYLCR";
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(string);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };
  return (
    <div>
      <Flex mt="10px" w="100%" alignItems="center" justifyContent="center">
        <Box
          bgGradient="linear(to-r, #53e0ac, #b958ee)"
          pl="20px"
          pr="20px"
          pt="10px"
          pb="10px"
          borderRadius="40px"
          w={{ base: "90%", md: "30%" }}
        >
          <HStack justifyContent="space-between" w="100%">
            <Box> CP Mint address</Box>
            <Box>
              <HStack>
                <Box fontWeight="600">{string?.slice(0, 12)}...</Box>
                <Box _hover={{ cursor: "pointer" }} onClick={handleClick}>
                  <FaRegCopy />
                </Box>
                {copied && <span>Copied!</span>}
              </HStack>
            </Box>
          </HStack>
        </Box>
      </Flex>
    </div>
  );
};

export default JustLaunched;
